<template>
  <Container group-name="ne-lv-elements" :get-child-payload="getPayload" @drop="onDrop">
    <Draggable v-for="(element, elementIndex) in currentColumn.elements" :key="elementIndex" class="ne-lv-single-object no-children">
      <section class="cursor-pointer" :class="{ active: activeObject && activeObject.id === element.id }">
        <div class="ne-lv-text" @click="clickObject(element)">
          <span>Element:</span>
          <label class="custom-ellipsis">{{ options2[element.id].ElementTitle }}</label>
        </div>
        <div class="ne-lv-buttons ml-2">
          <b-button v-if="options2[element.id].show" variant="primary" size="sm" title="Show / Hide" @click="clickToggleView(element.id)">
            <i :class="eyeIcon" />
          </b-button>
          <b-button v-else variant="danger" size="sm" title="Show / Hide" @click="clickToggleView(element.id)">
            <i :class="eyeSlashIcon" />
          </b-button>
          <b-button v-if="!options2[element.id].fromLanding" variant="outline-success" size="sm" title="Copy" class="ml-1" @click="clickCopy(element.id)">
            <i :class="cloneIcon" />
          </b-button>
          <b-button v-if="!options2[element.id].fromLanding" variant="outline-danger" size="sm" title="Delete" class="ml-1" @click="clickDelete(element.id)">
            <i :class="deleteIcon" />
          </b-button>
        </div>
      </section>
    </Draggable>
  </Container>
</template>

<script>
import { findIndex } from '@src/helper'
import { CLONE_ICON, DELETE_ICON, EYESLASH_ICON, EYE_ICON } from '@src/icons'
import { Container, Draggable } from 'vue-smooth-dnd'
export default {
  components: { Container, Draggable },
  props: {
    sections2: { type: Array, default: null, required: true },
    options2: { type: [Object], default: null, required: true },
    currentSection: { type: [Object], default: null, required: true },
    currentRow: { type: [Object], default: null, required: true },
    currentColumn: { type: [Object], default: null, required: true }
  },
  data() {
    return {
      cloneIcon: CLONE_ICON,
      deleteIcon: DELETE_ICON,
      eyeIcon: EYE_ICON,
      eyeSlashIcon: EYESLASH_ICON
    }
  },
  computed: {
    activeObject() {
      return this.$store.getters['utility/activeObject']
    }
  },
  methods: {
    callEvent(params) {
      this.$emit('callEvent', params)
    },
    findSectionIndex(id) {
      return findIndex(this.sections2, 'id', id)
    },
    findRowIndex(sectionId, id) {
      let index = -1
      const sectionIndex = this.findSectionIndex(sectionId)
      if (sectionIndex >= 0) {
        index = findIndex(this.sections2[sectionIndex].rows, 'id', id)
      }
      return [sectionIndex, index]
    },
    findColumnIndex(sectionId, rowId, id) {
      let index = -1
      const indexes = this.findRowIndex(sectionId, rowId)
      if (indexes[0] >= 0 && indexes[1] >= 0) {
        const sectionIndex = indexes[0]
        const rowIndex = indexes[1]
        index = findIndex(this.sections2[sectionIndex].rows[rowIndex].columns, 'id', id)
      }
      indexes.push(index)
      return indexes
    },
    getPayload(index) {
      const indexes = this.findColumnIndex(this.currentSection.id, this.currentRow.id, this.currentColumn.id)
      if (indexes[0] >= 0 && indexes[1] >= 0 && indexes[2] >= 0) {
        const sectionIndex = indexes[0]
        const rowIndex = indexes[1]
        const columnIndex = indexes[2]
        const element = this.sections2[sectionIndex].rows[rowIndex].columns[columnIndex].elements[index]
        return {
          ...element,
          source: 'ne-lv-elements'
        }
      }
      return null
    },
    onDrop(dragResult) {
      if (!dragResult) return
      const { removedIndex, addedIndex, payload } = dragResult
      const sectionId = this.currentSection.id
      const rowId = this.currentRow.id
      const columnId = this.currentColumn.id
      if (!payload || !payload.id) return

      const newElement = JSON.parse(JSON.stringify(payload))

      if (newElement.source === 'ne-lv-elements') {
        const indexes = this.findColumnIndex(sectionId, rowId, columnId)
        if (indexes[0] < 0 || indexes[1] < 0 || indexes[2] < 0) return

        const sectionIndex = indexes[0]
        const rowIndex = indexes[1]
        const columnIndex = indexes[2]

        if (removedIndex !== null && removedIndex >= 0) {
          this.sections2[sectionIndex].rows[rowIndex].columns[columnIndex].elements.splice(removedIndex, 1)
        }
        if (addedIndex !== null && addedIndex >= 0) {
          this.sections2[sectionIndex].rows[rowIndex].columns[columnIndex].elements.splice(addedIndex, 0, newElement)
        }
      }
    },
    clickObject(element) {
      this.callEvent({
        methodName: 'setActiveObject',
        eventData: { id: element.id, key: element.key, sectionId: this.currentSection.id, rowId: this.currentRow.id, columnId: this.currentColumn.id, type: 'element' },
        target: 'Design'
      })
      this.callEvent({ methodName: 'setDefaultEditorModal', target: 'Design' })
      const elementDOM = document.getElementById(element.id)
      if (elementDOM) elementDOM.scrollIntoView()
    },
    clickToggleView(elementId) {
      const options2 = JSON.parse(JSON.stringify(this.options2))
      options2[elementId].show = !options2[elementId].show
      this.callEvent({ methodName: 'setOptions2', eventData: options2, target: 'Design' })
    },
    clickCopy(elementId) {
      this.callEvent({
        methodName: 'copyElement',
        eventData: { sectionId: this.currentSection.id, rowId: this.currentRow.id, columnId: this.currentColumn.id, elementId }
      })
    },
    clickDelete(elementId) {
      this.callEvent({
        methodName: 'deleteElement',
        eventData: { sectionId: this.currentSection.id, rowId: this.currentRow.id, columnId: this.currentColumn.id, elementId }
      })
    }
  }
}
</script>